/**
 * Okta health status
 */

const OKTA_HEALTH_STATUS: any = {
  PENDING: 'PENDING',
  DOWN: 'DOWN',
  UP: 'UP',
}

/**
 * These custom groups of your Okta org manages users based on rules.
 * Ref: Sign in to your Okta Admin Console and click Directory > Groups
 */

const OKTA_GROUPS: any = {
  ACTIVE_MEMBERS: 'Active Members',
  ACTIVE_MEMBERS_TOU_ACCEPTED: 'Active Members - TOU Accepted',
  INACTIVE_MEMBERS: 'Inactive Members',
  EXPIRE_PASSWORD_ACCESS: 'Expire Password Access',
}

/**
 * When Auth Client methods resolve, they return a transaction object that
 * encapsulates the new state in the authentication flow. This transaction
 * contains metadata about the current state, and methods that can be used
 * to progress to the next state.
 * Ref: https://github.com/okta/okta-auth-js#transactionstatus
 */

const OKTA_TRANSACTION_STATUS: any = {
  /**
   * The user’s password was successfully validated but is expired.
   */
  PASSWORD_EXPIRED: 'PASSWORD_EXPIRED',

  /**
   * The user’s password was successfully validated but will expire soon so Okta is warning X days prior to expiration as defined in Okta.
   */
  PASSWORD_WARN: 'PASSWORD_WARN',

  /**
   * The user must verify the factor-specific recovery challenge.
   */
  RECOVERY_CHALLENGE: 'RECOVERY_CHALLENGE',

  /**
   * The user has requested a recovery token to reset their password or unlock
   * their account.
   */
  RECOVERY: 'RECOVERY',

  /**
   * The user successfully answered their recovery question and can set a
   * new password.
   */
  PASSWORD_RESET: 'PASSWORD_RESET',

  /**
   * The user login is verified but requires MFA and has mobile number registered.
   */
  MFA_REQUIRED: 'MFA_REQUIRED',

  /**
   * The user login is verified but requires MFA and does not have mobile number registered.
   */
  MFA_ENROLL: 'MFA_ENROLL',
  /**
   * The user must activate the factor to complete enrollment.
   */
  MFA_ENROLL_ACTIVATE: 'MFA_ENROLL_ACTIVATE',

  /**
   * The MFA OTP sent to user but requires verification.
   */
  MFA_CHALLENGE: 'MFA_CHALLENGE',

  /**
   * The end of the authentication flow! This transaction contains a sessionToken
   * you can exchange for an Okta cookie, an id_token, or access_token
   */
  SUCCESS: 'SUCCESS',

  /**
   * The user login is locked out and user needs to wait appropriate timespan defined in Okta before resetting password or trying to log in again
   */
  LOCKED_OUT: 'LOCKED_OUT',
}

const OKTA_FACTOR_RESULT_STATUS: any = {
  /**
   * Now Okta library handles factor status. This is part of the success ones
   */
  SUCCESS: 'SUCCESS',
  /**
   * When factor is triggered to be solved
   */
  CHALLENGE: 'CHALLENGE',
}

const OKTA_API_STATUS: any = {
  /**
   * The username sent to user's primary email address.
   */
  RECOVERED_USERNAME: 'RECOVERED_USERNAME',

  /**
   * The user password is changed.
   */
  PASSWORD_CHANGED: 'PASSWORD_CHANGED',
}

/**
 * Recovery factor to use for primary authentication
 * Ref: https://developer.okta.com/docs/reference/api/factors/#factor-type
 */
const OKTA_FACTOR_TYPE: any = {
  EMAIL: 'EMAIL',
}

/**
 * Local/Session storage keys
 */
const BROWSER_STORAGE_KEY: any = {
  LOGGED_OUT_OPERATION_DONE: 'loggedOutOperationDone',
  LOGGING_OPERATION_DONE: 'loggingOperationDone',
  REDIRECT_URL: 'redirectURL',
  IS_INACTIVE_MEMBER: 'isInactiveMember',
  USER: 'user',
  HAS_NO_ACCESS: 'hasNoAccess',
}

/**
 * Okta API generates error messages that can't be changed.
 * This is a list of how Okta error messages look like after being processed by our processErrorMsg() method.
 * It allows for replacing with custom message as requirements dictate by using CUSTOMIZED_OKTA_ERROR_MESSAGE
 */
const PROCESSED_OKTA_ERROR_MESSAGE: any = {
  PASSWORD_CANNOT_BE_CURRENT:
    'The password does not meet the complexity requirements of the current password policy. Password cannot be your current password. ',
}

/**
 * Okta API generates error messages that can't be changed.
 * This is a list of customized Okta error messages to be used as replacement.
 * Names match the original error messages in PROCESSED_OKTA_ERROR_MESSAGE
 */
const CUSTOMIZED_OKTA_ERROR_MESSAGE: any = {
  PASSWORD_CANNOT_BE_CURRENT:
    'The password does not meet the complexity requirements of the current password policy. The password cannot be your current password. Please enter a new password.',
}

/**
 * There are two ways to change user password:
 * 1. reset forgotten password as unauthenticated user
 * 2. change password as authenticated user
 * Depending on the path taken, need to pass one of these values to the backend to handle saving encrypted password correctly
 */
const PASSWORD_CHANGE_TYPE: any = {
  FORGOT_PASSWORD: 'forgotpassword',
  CHANGE_PASSWORD: 'changepassword',
}

const constants: any = {
  OKTA_HEALTH_STATUS,
  OKTA_GROUPS,
  OKTA_TRANSACTION_STATUS,
  OKTA_FACTOR_RESULT_STATUS,
  OKTA_API_STATUS,
  OKTA_FACTOR_TYPE,
  BROWSER_STORAGE_KEY,
  NO_REPLY_EMAIL_OKTA: process.env.REACT_APP_NO_REPLY_EMAIL_OKTA,
  NO_REPLY_EMAIL_AWS: process.env.REACT_APP_NO_REPLY_EMAIL_AWS,
  PROCESSED_OKTA_ERROR_MESSAGE,
  CUSTOMIZED_OKTA_ERROR_MESSAGE,
  PASSWORD_CHANGE_TYPE,
}

export default constants
